module.exports = __webpack_public_path__ + "assets/img/intro-vip-b2.baed2361.jpg";